<script async setup>
import { useDark } from '@vueuse/core'
import { useToggle } from '@vueuse/shared'

import AppBG from '~/components/AppBG.vue'

const isDark = useDark()
const toggleDark = useToggle(isDark)

const config = useRuntimeConfig()
const irisRight = ref(null)
const irisLeft = ref(null)
const route = useRoute()
let moveEye
const interval = null
const { data: lastshow } = await useFetch('/api/lastshowdate')

const { data: firstPlaceWinners } = await useFetch(`/api/champs?year=${route.params.year ? route.params.year : '2023'}`, { key: route.params.year ? `champs_${route.params.year}` : 'champs_2023' })
// firstPlaceWinners.value = data.value.firstPlaceWinners

const highlightIndex = computed(() => {
  // console.log(route.name)
  return route.name === 'index' || route.name === 'champ-contestant' || route.name === 'champs-year-year' // value.some(({name}) => /^(shows)$/);
})

const highlightShows = computed(() => {
  return (route.name === 'shows-year' || route.name === 'shows-watch-episode' || route.name === 'shows-watch-year-episode' || route.name === 'shows-watch-year$episode')
})

const highlightWhut = computed(() => {
  return route.name === 'whut'
})
const highlightStreaks = computed(() => {
  return route.name === 'streaks'
})

const highlightQuizculator = computed(() => {
  return route.name === 'quizculator'
})
</script>

<template>
  <div class="">
    <div class="sg-medium items-center">
      <!--      <div -->
      <!--        class="hidden md:flex w-screen h-5.5 fixed bg-green-500 top-0 text-white z-100" -->
      <!--      > -->
      <!--        <div class=""> -->
      <!--          <Vue3Marquee :pause-on-hover="true" class=""> -->
      <!--            <div -->
      <!--              v-for="i in 8" -->
      <!--              :key="i" -->
      <!--              class="px-3" -->
      <!--            > -->
      <!--              💪 &nbsp;&nbsp; Champ of 2023, so far&hellip; {{ firstPlaceWinners.firstPlaceWinners[0].name }} -->
      <!--            </div> -->
      <!--          </Vue3Marquee> -->
      <!--        </div> -->

      <!--        <div class="hidden md:block w-screen h-5.5 fixed bottom-0 z-100 bg-green-500"> -->
      <!--          <Vue3Marquee :pause-on-hover="true" :direction="'reverse'" class=""> -->
      <!--            <div -->
      <!--              v-for="i in 8" -->
      <!--              :key="i" -->
      <!--              class="px-3" -->
      <!--            > -->
      <!--              🎉 &nbsp;&nbsp; Champ of 2023, so far&hellip; {{ firstPlaceWinners.firstPlaceWinners[0].name }} -->
      <!--            </div> -->
      <!--          </Vue3Marquee> -->
      <!--        </div> -->
      <!--        <div class="hidden md:block h-screen w-5.5 fixed left-0 z-100 bg-green-500"> -->
      <!--          <Vue3Marquee :pause-on-hover="true" :direction="'reverse'" class="write-orient-upright h-screen z-100 rotate-90 z-100" style="overflow-x: revert !important"> -->
      <!--            <div -->
      <!--              v-for="i in 4" -->
      <!--              :key="i" -->
      <!--              class="px-3" -->
      <!--            > -->
      <!--              💪 &nbsp;&nbsp; Champ of 2023, so far&hellip; {{ firstPlaceWinners.firstPlaceWinners[0].name }} -->
      <!--            </div> -->
      <!--          </Vue3Marquee> -->
      <!--        </div> -->
      <!--        <div class="hidden md:block h-screen w-5.5 fixed right-0 bg-green-500 z-100"> -->
      <!--          <Vue3Marquee :pause-on-hover="true" class="write-orient-sideways h-screen rotate-90 " style="overflow-x: revert !important"> -->
      <!--            <div -->
      <!--              v-for="i in 4" -->
      <!--              :key="i" -->
      <!--              class="px-3" -->
      <!--            > -->
      <!--              🎉 &nbsp;&nbsp; Champ of 2023, so far&hellip; {{ firstPlaceWinners.firstPlaceWinners[0].name }} -->
      <!--            </div> -->
      <!--          </Vue3Marquee> -->
      <!--        </div> -->
      <!--      </div> -->
      <div class="h-screen md:pt-12">
        <!--    <div -->
        <!--      class="bg fixed inset-y-0 -inset-x-2/4 opacity-50 z-0 no-cpu hidden md:block" -->
        <!--    /> -->
        <!--    <div -->
        <!--      class="bg fixed inset-y-0 -inset-x-2/4 opacity-50 z-0 no-cpu hidden md:block" -->
        <!--    /> -->
        <!--    <div -->
        <!--      class="bg fixed inset-y-0 -inset-x-2/4 opacity-50 z-0 no-cpu hidden md:block" -->
        <!--    /> -->

        <AppBG class="fixed inset-y-0 -inset-x-2/4 no-cpu hidden md:block dark:bg-gray-600" />

        <div class="">
          <div class="flex items-center justify-center h-full relative">
            <div
              class="w-full md:max-w-screen-md lg:max-w-screen-lg relative bg-white bg-opacity-95 md:pt-4  md:border-3 md:border-green-500 dark:md:border-green-500  md:shadow-lg md:mb-4 dark:border-gray-900 dark:bg-gray-900 "
            >
              <div class="text-center">
                <div class="text-5xl sm:text-7xl">
                  <div class="i-twemoji-sports-medal absolute top-0 left-0" />
                </div>
                <button
                  class="absolute top-50 -left-5 i-fxemoji-sunglasses -rotate-10 text-5xl dark:hidden hidden md:flex z-100"
                  aria-label="Toggle dark mode" @click="toggleDark()"
                />
                <button
                  class="i-solar-moon-sleep-bold absolute top-50 -left-5 -rotate-0 text-orange-400 hidden md:dark:flex h-12 w-12 z-100"
                  aria-label="Toggle dark mode" @click="toggleDark()"
                >
                  <!--              <svg preserveAspectRatio="xMidYMid meet" viewBox="0 0 512 512"><path d="M401.4 354.2c-2.9.1-5.8.2-8.7.2-47.9 0-93-18.9-126.8-53.4-33.9-34.4-52.5-80.1-52.5-128.8 0-27.7 6.1-54.5 17.5-78.7 3.1-6.6 9.3-16.6 13.6-23.4 1.9-2.9-.5-6.7-3.9-6.1-6 .9-15.2 2.9-27.7 6.8C135.1 95.5 80 168.7 80 255c0 106.6 85.1 193 190.1 193 58 0 110-26.4 144.9-68.1 6-7.2 11.5-13.8 16.4-21.8 1.8-3-.7-6.7-4.1-6.1-8.5 1.7-17.1 1.8-25.9 2.2z" fill="currentColor" /></svg> -->
                </button>
                <div
                  class="i-twemoji-chart-increasing absolute top-0 right-0 md:-top-5 md:-right-5 text-5xl sm:text-7xl"
                />

                <div class="flex justify-center">
                  <nuxt-link to="/" class="">
                    <div class="flex items-center relative">
                      <h1 class="swing-hit text-3xl sm:text-5xl sg-bold relative z-50 dark:text-gray-50">
                        Crappy Stats
                      </h1>
                      <!--                  <NuxtImg src="/images/santa-hat-2.svg" alt="logo" class="w-6 sm:w-10 sm:w-12 absolute top-0 sm:-top-1.5 -left-3 sm:-left-7 -rotate-35 z-999" /> -->
                    </div>
                    <div class="uppercase inline-flex items-center dark:text-gray-50">
                      <span class="sg-regular text-sm">of</span>
                      <span class="ml-1 sg-bold">otb's</span>
                      <span
                        class="swing ml-1.5 p-x-1 p-y-0 sg-bold text-white -rotate-7 bg-[#ec0007] mt-1 relative z-100"
                      >crappy
                        quiz</span>
                    </div>
                  </nuxt-link>
                </div>
                <!--                <div -->
                <!--                  class="sm:absolute top-0 right-0 se-regular text-gray-800 sm:top-15 sm:-right-5 md:right-2" -->
                <!--                > -->
                <!--                  <div class="hidden md:block"> -->
                <!--                    <div class="face"> -->
                <!--                      <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"> -->
                <!--                        <rect width="58" height="60" fill-opacity="0" transform="translate(1)" /> -->
                <!--                        <circle cx="11" cy="23" r="6" stroke="#052837 dark:white" stroke-width="2" /> -->
                <!--                        <circle cx="49" cy="23" r="6" stroke="#052837 dark:white" stroke-width="2" /> -->
                <!--                        <path -->
                <!--                          d="M3 33.5C3 39 12 45 30 45C48 45 57 39 57 33.5" -->
                <!--                          stroke="#052837 dark:white" -->
                <!--                          stroke-width="2" -->
                <!--                          stroke-linecap="round" -->
                <!--                        /> -->
                <!--                      </svg> -->
                <!--                      <div ref="irisLeft" class="iris iris-left"> -->
                <!--                        <div /> -->
                <!--                      </div> -->
                <!--                      <div ref="irisRight" class="iris iris-right"> -->
                <!--                        <div /> -->
                <!--                      </div> -->
                <!--                    </div> -->
                <!--                  </div> -->
                <!--                </div> -->

                <div class="block">
                  <div
                    class="absolute top-8 z-0 w-[110px] sm:w-[125px] right-0 overflow-hidden sm:right-0 se-regular text-gray-800 sm:top-30 lg:-right-10 md:-right-5"
                  >
                    <NuxtImg
                      alt="last updated" class="rotate-7 sm:rotate-2 scale-70 md:scale-100" sizes="md:125px"
                      width="125" height="60" src="/images/transparent-red-price-sticker-2.webp"
                    />
                    <span
                      class="absolute rotate-3 top-4 left-5.5 sm:left-6.5 md:left-3 md:text-sm text-[0.6em] sm:text-[0.7em]"
                    >LAST
                      UPDATED</span>
                    <span
                      class="absolute rotate-4 top-7 md:top-9 left-8 md:left-6 md:text-sm text-[0.6em] sm:text-[0.7em]"
                    >
                      {{ lastshow.lastShow.date }}</span>
                  </div>
                </div>
              </div>
              <div class="flex items-center pl-4 sm:pl-10 pt-5">
                <div class="inline-flex flex-wrap items-center h-8">
                  <NuxtLink
                    :class="{ highlightIndex }" class="uppercase sg-bold text-white bg-[#ec0007] px-2 skew-x-20"
                    to="/champs/year/2023"
                  >
                    <div class="skew-x-160">
                      champs
                    </div>
                  </NuxtLink>

                  <NuxtLink
                    :class="{ highlightShows }"
                    class="ml-2 uppercase sg-bold text-white bg-[#ec0007] px-2 skew-x-20" to="/shows/2024"
                  >
                    <div class="skew-x-160">
                      shows
                    </div>
                  </NuxtLink>

                  <NuxtLink
                    :class="{ highlightStreaks }"
                    class="ml-2 uppercase sg-bold text-white bg-[#ec0007] px-2 skew-x-20" to="/streaks"
                  >
                    <div class="skew-x-160">
                      streaks
                    </div>
                  </NuxtLink>

                  <!--                  <NuxtLink -->
                  <!--                    :class="{ highlightQuizculator }" -->
                  <!--                    class="ml-2 uppercase sg-bold text-white bg-[#ec0007] px-2 -skew-x-20 hidden sm:block" -->
                  <!--                    to="/quizculator" -->
                  <!--                  > -->
                  <!--                    <div class="skew-x-20"> -->
                  <!--                      quizculator -->
                  <!--                    </div> -->
                  <!--                  </NuxtLink> -->

                  <NuxtLink
                    :class="{ highlightWhut }"
                    class="ml-2 uppercase sg-bold text-white bg-[#ec0007] px-2 skew-x-20 cursor-pointer" to="/whut"
                  >
                    <div class="skew-x-160">
                      whut?
                    </div>
                  </NuxtLink>
                </div>
              </div>
              <main>
                <slot />
              </main>
            </div>
          </div>
        </div>
        <div class="flex justify-center md:hidden dark:bg-gray-800 py-10">
          <button
            class="i-fxemoji-sunglasses text-5xl dark:hidden focus:outline-none active:bg-white"
            aria-label="dark mode button" @click="toggleDark()"
          />
          <button
            class="text-5xl text-orange-400 hidden dark:flex focus:outline-none active:bg-gray-800"
            aria-label="dark mode button" @click="toggleDark()"
          >
            <svg class="h-12 w-12" preserveAspectRatio="xMidYMid meet" viewBox="0 0 512 512">
              <path
                d="M401.4 354.2c-2.9.1-5.8.2-8.7.2-47.9 0-93-18.9-126.8-53.4-33.9-34.4-52.5-80.1-52.5-128.8 0-27.7 6.1-54.5 17.5-78.7 3.1-6.6 9.3-16.6 13.6-23.4 1.9-2.9-.5-6.7-3.9-6.1-6 .9-15.2 2.9-27.7 6.8C135.1 95.5 80 168.7 80 255c0 106.6 85.1 193 190.1 193 58 0 110-26.4 144.9-68.1 6-7.2 11.5-13.8 16.4-21.8 1.8-3-.7-6.7-4.1-6.1-8.5 1.7-17.1 1.8-25.9 2.2z"
                fill="currentColor"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="postcss">
.highlightIndex,
.highlightShows,
.highlightWhut,
.highlightStreaks,
.highlightQuizculator {
  box-shadow: rgba(34, 197, 94, 0.5) 6px 6px;
}

.bg {
  animation: slide 30s ease-in-out infinite alternate;
  animation-iteration-count: 2;
  background-image: linear-gradient(-60deg, #ec0007 50%, #d3d3d3 50%);
}

.bg:nth-child(2) {
  animation-direction: alternate-reverse;
  animation-duration: 30s;
  animation-iteration-count: 2;
}

.bg:nth-child(3) {
  animation-duration: 30s;
  animation-iteration-count: 3;
}

/*@keyframes slide {*/
/*  0% {*/
/*    transform: translateX(-25%);*/
/*  }*/
/*  100% {*/
/*    transform: translateX(25%);*/
/*  }*/
/*}*/

.no-cpu {
  transform: translateZ(0);
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  will-change: transform;
}

.iris {
  position: absolute;
  top: 23px;
  left: 11px;
}

.iris-right {
  left: 49px;
}

.iris div {
  position: relative;
  top: 0;
  left: 0;
  width: 6px;
  height: 6px;
  background-color: #052837;
  border-radius: 3px;
  transform: translate(-50%, -50%);
  transition:
    top 0.2s,
    left 0.2s;
}

html.dark .iris div {
  background-color: white;
  width: 5px;
  height: 5px;
}

html.dark .bg {
  animation: slide 30s ease-in-out infinite alternate;
  animation-iteration-count: 2;
  background-image: linear-gradient(-60deg, rgba(162, 18, 20, 0.99) 50%, black 50%);
}

html.dark .bg:nth-child(2) {
  animation-direction: alternate-reverse;
  animation-duration: 30s;
  animation-iteration-count: 2;
}

html.dark .bg:nth-child(3) {
  animation-duration: 30s;
  animation-iteration-count: 3;
}

.swing {
  animation: swing 4s ease-in-out;
  animation-delay: 2s;
  transform-origin: top left;
}

@keyframes swing {
  0%,
  100% {
    transform: rotate(30deg);
  }

  10% {
    transform: rotate(150deg);
  }

  20% {
    transform: rotate(-20deg);
  }

  30% {
    transform: rotate(120deg);
  }

  40% {
    transform: rotate(20deg);
  }

  50% {
    transform: rotate(90deg);
  }

  60% {
    transform: rotate(50deg);
  }

  70% {
    transform: rotate(60deg);
  }

  80% {
    transform: rotate(70deg);
  }

  90% {
    transform: rotate(60deg);
  }

  92% {
    transform: rotate(50deg);
  }

  95% {
    transform: rotate(40deg);
  }

  97% {
    transform: rotate(35deg);
  }
}

.swing-hit {
  animation: swing-hit 500ms;
  animation-delay: 6s;
  transform-origin: bottom left;
}

@keyframes swing-hit {
  0%,
  100% {
    transform: rotate(-3deg);
  }

  50% {
    transform: rotate(-4deg);
  }

  100% {
    transform: rotate(0deg);
  }
}
</style>
